import { buildAuthFunctions } from '../helpers.js';

const authFunctions = buildAuthFunctions('contacts');

export default {
    changeOwner: authFunctions.manage,
    ...authFunctions,
};